export const th = {
  nav: { invites: 'ลิงก์เชิญ', requests: 'คำขอ' },
  invite: {
    title: 'ลิงก์เชิญ',
    plural: 'ลิงก์เชิญ',
    create: 'สร้างลิงก์เชิญ',
    fields: {
      kind: 'ประเภท',
      name: 'เชิญใคร',
      branchId: 'สาขา',
      positionId: 'ตำแหน่ง',
      roleIds: 'บทบาทที่จะได้',
      employeeId: 'พนักงาน',
      driverId: 'คนขับรถร่วม',
      userId: 'บัญชี',
      expiresInHours: 'ใช้ได้กี่ชั่วโมง',
      token: 'รหัสลิงก์',
      expiresAt: 'หมดอายุ',
      status: 'สถานะ',
      usedAt: 'ใช้เมื่อ',
      usedByUserId: 'บัญชีที่สมัคร',
      createdByUserId: 'สร้างโดย',
      createdAt: 'สร้างเมื่อ',
      notes: 'หมายเหตุ',
    },
    options: {
      kind: { join: 'สมัครเข้าใช้งาน', reset: 'ตั้งรหัสผ่านใหม่' },
      status: { active: 'ใช้ได้', used: 'ใช้แล้ว', revoked: 'ยกเลิกแล้ว', expired: 'หมดอายุ' },
    },
    actions: { revoke: 'ยกเลิกลิงก์', copy: 'คัดลอกลิงก์', copied: 'คัดลอกแล้ว', share: 'แชร์', showQr: 'แสดง QR', reset: 'ลิงก์ตั้งรหัสผ่านใหม่' },
    rolesHint: 'ตามตำแหน่ง ให้ได้เฉพาะบทบาทที่คุณมีสิทธิ์ให้',
    expiresHint: 'ลิงก์ใช้ได้ครั้งเดียว',
    scanHint: 'ให้สแกนด้วยกล้องมือถือ หรือส่งลิงก์ทางแชท',
    makerOnly: 'ลิงก์นี้ดูได้เฉพาะคนที่สร้าง เพราะใครมีลิงก์ก็เข้าบัญชีได้ ถ้าต้องการลิงก์ใหม่ให้สร้างลิงก์ใหม่ แล้วยกเลิกอันนี้',
  },
  request: {
    title: 'คำขอ',
    plural: 'คำขอเปิดบัญชีและขอใช้แอพ',
    fields: {
      kind: 'ประเภท',
      userId: 'ผู้ขอ',
      applicantName: 'ชื่อผู้ขอ',
      applicantPhone: 'เบอร์โทร',
      username: 'ชื่อผู้ใช้',
      appId: 'แอพ',
      branchId: 'สาขา',
      positionId: 'ตำแหน่ง',
      reason: 'เหตุผล',
      requestedAt: 'ขอเมื่อ',
      status: 'สถานะ',
      grantedRoleIds: 'บทบาทที่ให้',
      reviewedByUserId: 'พิจารณาโดย',
      reviewedAt: 'พิจารณาเมื่อ',
      rejectReason: 'เหตุผลที่ไม่อนุมัติ',
      employeeId: 'พนักงาน',
    },
    options: {
      kind: { signup: 'ขอเปิดบัญชี', app: 'ขอใช้แอพ' },
      status: { pending: 'รออนุมัติ', approved: 'อนุมัติแล้ว', rejected: 'ไม่อนุมัติ', cancelled: 'ยกเลิกแล้ว' },
    },
    actions: { approve: 'อนุมัติ', reject: 'ไม่อนุมัติ', cancel: 'ยกเลิกคำขอ' },
    rolesHint: 'ให้ได้เฉพาะบทบาทที่คุณมีสิทธิ์ให้',
    approved: 'อนุมัติแล้ว {{name}} เข้าใช้งานได้เลย',
    rejected: 'ไม่อนุมัติคำขอของ {{name}}',
  },
} as const

export const en = {
  nav: { invites: 'Invite links', requests: 'Requests' },
  invite: {
    title: 'Invite link',
    plural: 'Invite links',
    create: 'New invite link',
    fields: {
      kind: 'Type',
      name: 'For',
      branchId: 'Branch',
      positionId: 'Position',
      roleIds: 'Roles given',
      employeeId: 'Employee',
      driverId: 'Contract driver',
      userId: 'Account',
      expiresInHours: 'Valid for (hours)',
      token: 'Link code',
      expiresAt: 'Expires',
      status: 'Status',
      usedAt: 'Used',
      usedByUserId: 'Account made',
      createdByUserId: 'Created by',
      createdAt: 'Created',
      notes: 'Notes',
    },
    options: {
      kind: { join: 'Join', reset: 'Reset password' },
      status: { active: 'Active', used: 'Used', revoked: 'Revoked', expired: 'Expired' },
    },
    actions: {
      revoke: 'Revoke link',
      copy: 'Copy link',
      copied: 'Copied',
      share: 'Share',
      showQr: 'Show QR',
      reset: 'Password reset link',
    },
    rolesHint: "The position's; only roles you may give",
    expiresHint: 'Each link works once',
    scanHint: "Scan it with the phone's camera, or send the link in a chat",
    makerOnly:
      'Only whoever made this link sees it: anyone who has it gets into the account. For a new one, make a new link and revoke this one.',
  },
  request: {
    title: 'Request',
    plural: 'Account and app requests',
    fields: {
      kind: 'Type',
      userId: 'Requested by',
      applicantName: 'Name',
      applicantPhone: 'Phone',
      username: 'Username',
      appId: 'App',
      branchId: 'Branch',
      positionId: 'Position',
      reason: 'Reason',
      requestedAt: 'Requested',
      status: 'Status',
      grantedRoleIds: 'Roles given',
      reviewedByUserId: 'Reviewed by',
      reviewedAt: 'Reviewed',
      rejectReason: 'Why not',
      employeeId: 'Employee',
    },
    options: {
      kind: { signup: 'New account', app: 'App access' },
      status: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected', cancelled: 'Withdrawn' },
    },
    actions: { approve: 'Approve', reject: 'Reject', cancel: 'Withdraw' },
    rolesHint: 'Only roles you may give',
    approved: '{{name}} is approved and can sign in now',
    rejected: "{{name}}'s request was rejected",
  },
} as const
